import React, { useEffect, useState } from 'react'
import ProjectGrid from '../sections/ProjectGrid'
import CampaignShowcase from '../sections/CampaignShowcase';
import SubCategoryIntro from '../sections/SubCategoryIntro';
import { useLocation } from 'react-router';
import ResourceList from '../sections/ResourceList';
import AnimatedButton from '../animates/AnimatedButton'
import { Icon } from '@mui/material';
import ProjectDetail from '../sections/ProjectDetail';
import ProjectPublicRead from '../sections/ProjectPublicRead';

// import { ButtonContent, Button, Icon } from 'semantic-ui-react'

function ProjectSubCategoryPage() {
  const location = useLocation()

  const [intro,setIntro]=useState({
    title: "Building Climate Resilience in Coastal Communities",
    category: "Adaptation",
    description:
      "Empowering local communities to protect shorelines, preserve livelihoods, and adapt to the changing climate.",
    type: "image", // can be "image", "video", or "audio"
    // media: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
    media: "http://www.fountainafrica.org/wp-content/uploads/2025/10/IMG-20210823-WA0058.jpg",
  })
  useEffect(()=>{
      if(location?.state?.subcategory){
        setIntro({
          title: location?.state?.subcategory?.name,
          category: location?.state?.subcategory?.category?.name,
          description: location?.state?.description,
          type: "image", // can be "image", "video", or "audio"
          // media: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
          media: location?.state?.subcategory?.image_introduction,
        })
      }
    },[location?.state])

  const campaignExample = {
    title: "Building Climate Resilience in Coastal Communities",
    category: "Adaptation",
    description:
      "Empowering local communities to protect shorelines, preserve livelihoods, and adapt to the changing climate.",
    type: "image", // can be "image", "video", or "audio"
    // media: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
    media: "http://www.fountainafrica.org/wp-content/uploads/2025/10/IMG-20210823-WA0058.jpg",
  };

  const relatedArticles = [
    { title: "Sustainable Wells Initiative", image: "https://picsum.photos/400/250?random=1", date: "August 21, 2025" },
    { title: "Empowering Local Communities", image: "https://picsum.photos/400/250?random=2", date: "August 18, 2025" },
    { title: "Improving Access to Clean Water", image: "https://picsum.photos/400/250?random=3", date: "August 10, 2025" }
  ];
  
  return (
    <div>
        {/* intro */}
        <SubCategoryIntro campaign={intro} />
        {/* Feature Campaigns */}
        {/* <CampaignShowcase campaign={campaignExample} /> */}
        {/* Project list for the category */}
        {location?.state?.isProjectView===false?<section className="campaign-info-section">
          <div className="campaign-info-container">
            <div className="campaign-info-line"></div>
            {/* <h2 className="campaign-info-title">{`${intro?.tag}`}</h2> */}
            <h2 className="campaign-info-title">{`${intro?.title}`}</h2>
            <p className="campaign-info-text">
              {intro?.content}
            </p>
            <p className="campaign-info-text">
              {intro?.description}
            </p>
            {/* <p className="campaign-info-text"> */}
            {/* <AnimatedButton/> */}
            <button className="Donate-Subcategory" type="button">
              {/* <Icon></Icon> */}
              {/* {`Support ${intro?.title}`} */}
              test
            </button>
            {/* </p> */}
          </div>
        </section>:""}
        {/* <h2>Detal SubCategory</h2> */}
        {/* <ProjectGrid /> */}
        <ProjectPublicRead/>
    </div>
  )
}

export default ProjectSubCategoryPage